import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import { ButtonAddRoute, TextAddRoute, TextTitlePage } from "./styles";
import {
  Header,
  Container,
  Content,
  Button,
  ContentButton,
  IconButton,
} from "../../../../components";
import CardRoutes from "../../../../components/CardRoutes";
import { themes } from "../../../../design/colors";
import RouteContext from "../../../../context/route";

function ListRoutesDriver() {
  const navigation = useNavigation();
  const { newRoute, registerRoute, loading } = useContext(RouteContext);

  function handleNewRoute() {
    navigation.navigate("NewRouteDriver");
  }

  async function handleSubmit() {
    await registerRoute(newRoute);
  }

  return (
    <Container>
      <Header type="simple" title="Rotas" />
      <Content>
        <Button title="Adicionar rota" onPress={handleNewRoute} />
        {newRoute.routes.map((item: any, index: number) => (
          <CardRoutes
            first={index === 0 && true}
            title={item.recipientName}
            subtitle={item.noteNumber}
            icon="route"
            iconAction="arrow-right"
            onPress={() => {}}
          />
        ))}
      </Content>
      <ContentButton align="flex-end">
        <IconButton
          accessible
          accessibilityLabel="Avançar"
          accessibilityRole="button"
          loading={loading}
          accessibilityHint="Avançar para próxima tela"
          onPress={handleSubmit}
          color={themes.colors.primary}
        />
      </ContentButton>
    </Container>
  );
}

export default ListRoutesDriver;
